export const iconFontAwesomeMedicalHealthVirus = (
	<i className="fa-solid fa-virus"></i>
);
